import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NeoLogService {

  // See app.component.ts for settings of this property
  public isLoggingEnabled: boolean = false;
  public showDebug: boolean = false;

  public log(...args: unknown[]): void {
    if (this.isLoggingEnabled) {
      console.log(...args);
    }
  }

  public error(...args: unknown[]): void {
    if (this.isLoggingEnabled) {
      console.error(...args);
    }
  }

  public warn(...args: unknown[]): void {
    if (this.isLoggingEnabled) {
      console.warn(...args);
    }
  }

  public info(...args: unknown[]): void {
    if (this.isLoggingEnabled) {
      console.info(...args);
    }
  }

  public debug(...args: unknown[]): void {
    if (this.isLoggingEnabled) {
      console.debug(...args);
    }
  }

  public trace(...args: unknown[]): void {
    if (this.isLoggingEnabled) {
      console.trace(...args);
    }
  }
}
